<div class="flex g-20">
  <div
    class="breadcrumb"
    [class.white]="color() === 'white'"
    [class.grey]="color() === 'grey'"
    *ngFor="let breadcrumb of breadcrumbs(); let last = last"
  >
    <p
      *ngIf="breadcrumb.url"
      class="breadcrumb-text"
      routerLinkActive="router-link-active"
      (click)="navigate(breadcrumb.url, breadcrumb.tab)"
    >
      {{ breadcrumb.name }}
    </p>

      <p
      *ngIf="!breadcrumb.url"
      class="breadcrumb-text-disabled"
    >
      {{ breadcrumb.name }}
    </p>
    <svg-icon class="arrow-icon" *ngIf="!last" name="patriot_arrow"></svg-icon>
  </div>
</div>
